import React from 'react'
import CognitoUserManagement from './CognitoUserManagement'

import FormatCheckTextBox from '../../../../common/component/FormatCheckTextBox'
import Window from '../../../../common/Window'

class CognitoUserAdd extends CognitoUserManagement {
  getInitialState () {
    return {
      isNew: true,
      enabled: '',
      createdDateTime: '',
      updatedDateTime: '',
      status: '',
      id: '',
      email: '',
      name: '',
      emailNotification: 'true',
      prefectures: '',
      branch: '',
      administrator: '',
      isMember: 'true',
      approvalFlg: 'false',
      parentID: ''
    }
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  loadUserDetail (id) {
  }
  renderUserDetail (title, nameTitle, userDetail, isNew) {
    const actionTitle = '新規登録'
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    if(this.userRoleUrl == 'company_user') {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>メールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    } else {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>会社所在地都道府県名</label>
            <div className='controls'><input type='text' name='prefectures' className='span5' value={userDetail.prefectures} autoComplete='false' onChange={e => this.changed('prefectures', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>支部名</label>
            <div className='controls'><input type='text' name='branch' className='span5' value={userDetail.branch} autoComplete='false' onChange={e => this.changed('branch', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者名</label>
            <div className='controls'><input type='text' name='administrator' className='span5' value={userDetail.administrator} autoComplete='false' onChange={e => this.changed('administrator', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者メールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    }
  }
  addUserNoLogin (newUser) {
    newUser.name = newUser.name.trim()
    newUser.email = newUser.email.trim()
    if (newUser.name === '') {
      Window.alert(this.nameTitle + 'は必須です。')
      return false
    }
    if (newUser.email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    const onSuccess = (res) => {
      if (res.body.isOK) {
        console.log(res.body)  //デバッグ時以外はコメントアウト
        Window.alert(this.userRoleName + '情報を登録しました\n登録されたメールアドレスにメールをお送りいたします', () => {
          let detailUrl = '/company_admin/login'
          this.props.history.push(detailUrl)
          Window.closeDialog()
        })
      } else {
        // Cognito は重複メールアドレス時に UsernameExistsException を返し、
        // その message は 'User account already exists' など複数パターンがある。
        // ※ 従来は 'An account with the email already exists.' との完全一致でしか
        //   判定しておらず、実際のメッセージに一致せず「登録時にエラーが発生しました」と
        //   表示され、会員が原因を理解できず再登録を繰り返していた(NKK-158)。
        const message = res.body.message || ''
        const isDuplicate =
          res.body.code === 'UsernameExistsException' ||
          message.indexOf('already exists') !== -1
        if (isDuplicate) {
          Window.alert('既に登録済みのメールアドレスです。')
          return false
        }
        console.log(res) //デバッグ時以外はコメントアウト
        Window.alert('登録時にエラーが発生しました')
      }
    }
    this.addCognitoUserNoLogin(newUser, onSuccess)
  }
  render () {
    const userDetail = this.renderUserDetail(this.userRoleName + '情報', this.nameTitle, this.state, this.state.isNew)
    const title = '新規登録'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>日本型枠工事業協会 {this.userRoleName}情報 - {title}<br /><small>こちらで{this.userRoleName}の情報を{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='alert alert-block alert-info'>
              <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
            </div>
            {userDetail}
            <p class="offset1">info@nikkendaikyou.netからのメールの受信許可をお願いします。<br />※キャリアメールの方は各社サイトで設定をご確認ください。</p>
            <footer id='submit-actions' className='form-actions'>
              <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
            </footer>
          </form>
        </section>
      </div>
    )
  }
}

export default CognitoUserAdd



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/abstract/CognitoUserAdd.js